export const waitUntil = (conditionFn: () => boolean, interval = 100) => {
	return new Promise((resolve) => {
		const check = () => {
			if (conditionFn()) {
				resolve();
			} else {
				setTimeout(check, interval);
			}
		};
		check();
	});
};
